import gql from 'graphql-tag';

const previouslyViewedSearchQuery = gql`
    query($request: SearchResultRequest!) {
        previouslyViewedSearch(request: $request) {
            listings {
                averageRating
                bedrooms
                detailPageUrl
                headlinePhoto {
                    uri
                }
                listingId
                priceSummary {
                    formattedAmount
                    pricePeriodDescription
                }
                propertyMetadata {
                    headline
                }
                reviewCount
                sleeps
            }
        }
    }
`;

export default previouslyViewedSearchQuery;
